var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 55,
    viewBox: "0 0 76 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.817 30.7964C29.8752 30.7964 23.414 37.2575 23.414 45.1993V54.0627H52.2199V45.1993C52.2199 37.2575 45.7588 30.7964 37.817 30.7964Z",
    fill: "#FF3811"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7882 20.8243C47.7882 15.3257 43.3156 10.853 37.817 10.853C32.3184 10.853 27.8457 15.3257 27.8457 20.8243C27.8457 26.3229 32.3184 30.7956 37.817 30.7956C43.3156 30.7956 47.7882 26.3229 47.7882 20.8243Z",
    fill: "#FF3811"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.522 10.8536C24.522 5.35497 20.0493 0.882324 14.5507 0.882324C9.05205 0.882324 4.57941 5.35497 4.57941 10.8536C4.57941 16.3522 9.05205 20.8249 14.5507 20.8249C20.0493 20.8249 24.522 16.3522 24.522 10.8536Z",
    fill: "#444444"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0833 20.8247C55.2298 20.8247 50.202 24.3481 47.9515 29.3742C53.1686 32.7268 56.6516 38.5508 56.6516 45.1989H75.6339V35.2277C75.6339 27.2858 69.0251 20.8247 61.0833 20.8247Z",
    fill: "#444444"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0545 10.8536C71.0545 5.35497 66.5819 0.882324 61.0833 0.882324C55.5846 0.882324 51.112 5.35497 51.112 10.8536C51.112 16.3522 55.5846 20.8249 61.0833 20.8249C66.5819 20.8249 71.0545 16.3522 71.0545 10.8536Z",
    fill: "#444444"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6824 29.3742C25.4319 24.3481 20.4042 20.8247 14.5507 20.8247C6.60885 20.8247 0 27.2858 0 35.2277V45.1989H18.9824C18.9824 38.5508 22.4654 32.7268 27.6824 29.3742Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.5981768adc66f90dc3e6536dafeb2e04.svg";
export { ForwardRef as ReactComponent };